import React from 'react';
// import { Navigate } from 'react-router-dom';

// Pages Component
import Chat from '../pages/Chat/Chat';

const authProtectedRoutes = [
];

const publicRoutes = [
  { path: '/nuevo/chat', component: <Chat /> }
];

export { authProtectedRoutes, publicRoutes };
